import React from "react";

import { ReactComponent as Icon } from "../../assets/svg/actionBubble.svg";

import styles from "./ActionBubbleIcon.module.scss";
type ActionBubbleIconProps = {
  onClose: () => void;
};

const ActionBubbleIcon: React.FC<ActionBubbleIconProps> = ({ onClose }) => {
  return (
    <div className={styles.container} onClick={onClose}>
      <div className={styles.icon}>
        <Icon />
      </div>
    </div>
  );
};

export default ActionBubbleIcon;
